import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { Activity } from '../shared/models';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  private activitiesStorage: Storage | null = null;

  constructor(private storage: Storage) {
    this.init();
  }

  async init() {
    // If using, define drivers here: await this.storage.defineDriver(/*...*/);
    const storage = await this.storage.create();
    this.activitiesStorage = storage;
  }

  // Create and expose methods that users of this service can
  // call, for example:
  set(key: string, value: Activity) {
    this.activitiesStorage?.set(key, value);
  }

  promiseSet(value: Activity): Promise<void> {
    const key = Math.floor(new Date(value.start_date_local).getTime() /1000).toString();
    return this.activitiesStorage?.set(key, value).then(() => {});
  }

  get(key: string): Promise<Activity> {
    return this.activitiesStorage?.get(key).then((val) => val);
  }

  clear() {
    this.activitiesStorage?.clear();
  }

  addActivities(activities: Activity[]) {
    activities.forEach(activity => {
      const key = Math.floor(new Date(activity.start_date_local).getTime() /1000).toString();
      this.set(key, activity);
    });
    this.removeNonFavActivities();
  }


  getAllKeys() {
    return this.activitiesStorage?.keys().then((val)=>val);
  }

  getAllActivities(): Promise<Activity[]> {
    return this.storage.keys().then(keys => Promise.all(keys.sort().reverse().map(k => this.storage.get(k))));
  }

  removeOldActivities(){
    this.getAllKeys().then((items: any) => {
      items.forEach(entry => {
        this.activitiesStorage.remove(entry).then(()=>{
        //  console.log(entry, ' removed');
        });
      });
    });
  }

  removeNonFavActivities(){
    this.getAllKeys().then((items: any) => {
      items.forEach(entry => {
        this.storage.get(entry).then(activity=>{
          if (!activity.isFavorite){
            this.activitiesStorage.remove(entry).then(()=>{});
          }
        });
      });
    });
  }

  removeAllActivities(): Promise<any>{
    return this.storage.clear();
  }

}
